import React from "react";
import { useSelector } from "react-redux";

import { i18, trb } from "@utilities";
import { AddRemoveInputs, FullWidthInputWrapper, StepperFormRow } from "@components";
import { selectFundsSentCountries } from "@redux";
import { ClientFundSentCountry } from "../elements/ClientFundSentCountry";

export const ClientFundsSentCountries = ({
  control,
  unregister,
  totalSentCountries,
  setTotalSentCountries
}) => {
  const clientFundstSentCountries = useSelector(selectFundsSentCountries);

  return (
    <StepperFormRow>
      <FullWidthInputWrapper>
        <p className="form-part-note">{trb(i18.Labels.FundsSentTo)}</p>
      </FullWidthInputWrapper>
      {new Array(totalSentCountries).fill(null).map((_, index) => (
        <ClientFundSentCountry
          control={control}
          countryIndex={index}
          key={clientFundstSentCountries[index]?.value}
        />
      ))}
      <AddRemoveInputs
        totalInputsAdded={totalSentCountries}
        maxInputsAllowed={clientFundstSentCountries.length}
        onAdd={() => setTotalSentCountries(prev => prev + 1)}
        onRemove={() => {
          unregister(`clientFundsSentCountry.${totalSentCountries - 1}`);
          setTotalSentCountries(prev => prev - 1);
        }}
      />
    </StepperFormRow>
  );
};
